import { agrupaMenu2810 } from './agrupa2810Logic'; // AGRUPA_2810
// MENU_ORDEM_2810 (GROK2) — lógica pura (sem JSX), testável em node.
// Menu PLANO (sem cabeçalhos de grupo, sem abrir/fechar), na ordem pedida pelo Gustavo.
export const MENU_HIDDEN_2810 = new Set([
  '/gestor-xui/live-clients', '/gestor-xui/inactive-clients', '/gestor-xui/inactive-resellers', '/sales', '/app-activations',
]);
const RENAME = { '/atendimento': 'DataCrazy Chat', '/dashboard': 'Dashboard', '/logs-globais': 'Registros globais', '/gestor-xui/reseller-billing': 'Modos de revenda' };
// Blocos (só para o divisor fino entre eles; não aparecem como título).
const BLOCKS = [
  ['b-inicio', ['/dashboard', '/comunicados']],
  ['b-atendimento', ['/chats', '/atendimento', '/reunioes', '/notification-templates', '/materiais', '/admin/materiais', '/contacts', '/funnel', '/aurax-ai', '/triggers/chatbot', '/triggers', '/recuperacao']],
  ['b-clientes', ['/gestor-xui/clients', '/gestor-xui/tests', '/gestor-xui/vencimentos', '/gestor-xui/passo-a-passo', '/bonification', '/gestor-xui/my-portfolio']],
  ['b-financeiro', ['/financeiro', '/logs-financeiros', '/gestor-xui/credit-logs', '/buy-credits', '/postpaid-wallet']],
  ['b-revendas', ['/gestor-xui/resellers', '/gestor-xui/credit-packs', '/gestor-xui/reseller-billing', '/gestor-xui/my-reseller-billing']],
  ['b-migracao', ['/gestor-xui/reseller-migration']],
  ['b-catalogo', ['/gestor-xui/partner-apps', '/gestor-xui/categories', '/gestor-xui/plan-pricing', '/gestor-xui/own-player']],
  ['b-conteudos', ['/gestor-xui/catalog', '/connections', '/team']],
  ['b-config', ['/settings', '/community-support', '/gestor-xui/servers', '/permissions', '/gestor-xui/credential-generation']],
  ['b-resto', []],
  ['b-fim', ['/gestor-xui/gateway', '/api-integrations', '/ranking', '/logs-globais']],
];
// Item que não está na lista acima vai para o bloco "natural" do grupo antigo dele.
// MENU_WHATS_2810 (GROK2): WhatsApp em 2 blocos planos seguidos. Switch private/MENU_WHATS_2810_OFF.
const BLOCKS_WHATS_2810 = BLOCKS.flatMap(([id, ps]) => {
  if (id === 'b-atendimento') return [
    ['b-datacrazy', ['/atendimento', '/chats']],
    ['b-atendimento', ['/connections', '/conversas', '/contacts', '/funnel', '/triggers/chatbot', '/aurax-ai', '/triggers', '/recuperacao', '/notification-templates']],
    ['b-geral', ['/reunioes', '/materiais', '/admin/materiais']],
  ];
  return [[id, ps.filter((p) => p !== '/connections')]];
});
const OLD_TO_BLOCK = { home: 'b-inicio', crm: 'b-atendimento', gestao: 'b-clientes', creditos: 'b-financeiro', applications: 'b-catalogo', iptv: 'b-catalogo', admin: 'b-conteudos', config: 'b-config' };

// MENU_ENXUTO_2810 (GROK2): menu enxuto. Só esconde/funde no menu; as páginas continuam e
// ganham abas internas (ver ENXUTO_TABS_2810 em menuOrdem2810.js). Switch private/MENU_ENXUTO_2810_OFF.
export const ENXUTO_HIDDEN_2810 = new Set([
  '/comunicados', '/bonification', '/ranking', '/community-support', '/gestor-xui/own-player',
  '/logs-financeiros', '/gestor-xui/credit-logs',          // abas dentro de Financeiro
  '/gestor-xui/servers', '/gestor-xui/credential-generation', // abas dentro de Ajustes
  '/api-integrations',                                       // aba dentro de Integrações
  '/permissions',                                            // aba dentro de Equipe
  '/gestor-xui/categories',                                  // aba dentro de Catálogo e Planos
]);
const ENXUTO_RENAME = { '/gestor-xui/gateway': 'Integrações', '/gestor-xui/partner-apps': 'Catálogo e Planos' };
const ENXUTO_TOP = [['b-topo', ['/dashboard', '/atendimento', '/chats', '/gestor-xui/clients', '/gestor-xui/tests']]];
const ENXUTO_TOP_WHATS_2810 = ['/dashboard', '/gestor-xui/clients', '/gestor-xui/tests'];

// AGRUPA_2810: aplica o agrupamento (Financeiro/Clientes/Catálogo) por cima da ordem atual.
export function reorderMenu2810(groups = [], opts = {}) {
  const out = reorderMenu2810Base(groups, opts);
  return opts.agrupa ? agrupaMenu2810(out, groups, opts.agrupa) : out;
}
function reorderMenu2810Base(groups = [], opts = {}) {
  if (opts.enxuto) {
    const hide = new Set([...MENU_HIDDEN_2810, ...ENXUTO_HIDDEN_2810]);
    // FIN_REVENDA_2910: Movimentações/Extrato da revenda vão para Registros (agrupa) em vez de abas do Financeiro
    if (opts.agrupa && opts.agrupa.fin_revenda && !opts.isAdmin) { hide.delete('/logs-financeiros'); hide.delete('/gestor-xui/credit-logs'); }
    // AUDITORIA_REVENDA_2810: revenda não tem as abas de admin -> mantém no menu o que ela só acharia por aba.
    if (opts.revendaFix && !opts.isAdmin) {
      const has = new Set(groups.flatMap((g) => (g.items || []).map((i) => i.path)));
      hide.delete('/comunicados'); hide.delete('/gestor-xui/credit-logs');
      if (!has.has('/gestor-xui/gateway')) hide.delete('/api-integrations');
      if (!has.has('/gestor-xui/partner-apps')) hide.delete('/gestor-xui/categories');
    }
    const topList = opts.whats ? ENXUTO_TOP_WHATS_2810 : ENXUTO_TOP[0][1];
    const top = new Set(topList);
    const base = reorderMenu2810Base(groups, { whats: opts.whats, chatsWhats: opts.chatsWhats });
    const byPath = new Map(base.flatMap((g) => g.items.map((i) => [i.path, i])));
    const topItems = topList.map((p) => byPath.get(p)).filter(Boolean);
    const out = topItems.length ? [{ id: 'b-topo', label: '', flat2810: true, items: topItems, defaultPath: topItems[0].path }] : [];
    for (const g of base) {
      const items = g.items.filter((i) => !top.has(i.path) && !hide.has(i.path))
        .map((i) => (ENXUTO_RENAME[i.path] ? { ...i, label: ENXUTO_RENAME[i.path] } : i));
      if (items.length) out.push({ ...g, items, defaultPath: items[0].path });
    }
    return out;
  }
  const byPath = new Map(); const oldGroup = new Map();
  for (const g of groups) for (const it of g.items || []) if (it.path && !byPath.has(it.path)) { byPath.set(it.path, it); oldGroup.set(it.path, g.id); }
  // CHATS_WHATS_2810 (GROK2): /chats (Atendimentos) entra no bloco WhatsApp, logo depois de Conexões.
  const blocks = opts.whats ? (opts.chatsWhats ? BLOCKS_WHATS_2810.map(([id, ps]) => id === 'b-datacrazy' ? [id, ps.filter((p) => p !== '/chats')]
    : id === 'b-atendimento' ? [id, ['/connections', '/chats', ...ps.filter((p) => p !== '/connections')]] : [id, ps]) : BLOCKS_WHATS_2810) : BLOCKS;
  const listed = new Set(blocks.flatMap(([, ps]) => ps));
  const extra = {};
  for (const [p] of byPath) {
    if (listed.has(p) || MENU_HIDDEN_2810.has(p)) continue;
    const b = OLD_TO_BLOCK[oldGroup.get(p)] || 'b-resto';
    (extra[b] = extra[b] || []).push(p);
  }
  const used = new Set(); const out = [];
  for (const [id, ps] of blocks) {
    const items = [...ps, ...(extra[id] || [])].map((p) => {
      const it = byPath.get(p);
      if (!it || used.has(p) || MENU_HIDDEN_2810.has(p)) return null;
      used.add(p);
      return RENAME[p] ? { ...it, label: RENAME[p] } : it;
    }).filter(Boolean);
    if (items.length) out.push({ id, label: '', flat2810: true, items, defaultPath: items[0].path });
  }
  return out;
}
